const languages = [
 {
  name: 'English',
  alternate_name: 'अंग्रेज़ी',
  locale: 'en',
 },
 {
  name: 'हिंदी',
  alternate_name: 'Hindi',
  locale: 'hi',
 },
 // {
 //   name: 'বাংলা ',
 //   alternate_name: 'Bangla',
 //   locale: 'bn',
 // },
 {
  name: 'मराठी ',
  alternate_name: 'Marathi',
  locale: 'mr',
 },
 // {
 //   name: 'ઓડિયા',
 //   alternate_name: 'Odia',
 //   locale: 'or',
 // },
 // {
 //   name: 'ગુજરાતી',
 //   alternate_name: 'Gujarati',
 //   locale: 'gu',
 // },
 // {
 //   name: 'தமிழ்',
 //   alternate_name: 'Tamil',
 //   locale: 'ta',
 // },
 {
  name: 'తెలుగు',
  alternate_name: 'Telugu',
  locale: 'te',
 },
 {
  name: 'கன்னடம்',
  alternate_name: 'Kannada',
  locale: 'kn',
 },
 // {
 //   name: 'மலையாளம்',
 //   alternate_name: 'Malayalam',
 //   locale: 'ml',
 // },
]

export default languages
